"use client";

import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";

export function useRedirectToPaymentPage() {
  const router = useRouter();
  const { status } = useSession();

  const redirectToPaymentPage = () => {
    if (status !== "authenticated") {
      router.push("/signin");
      return;
    }

    router.push("/payment");
  };

  return { redirectToPaymentPage };
}
